<!--
 * @Author: zl
 * @Date: 2022-09-15 15:13:09
 * @LastEditTime: 2022-09-16 14:10:59
 * @LastEditors: zl
 * @Description: 会议纪要
-->
<template>
	<div class='MeetingMinutes-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">会 议 纪 要</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="会议主题"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="主持人">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="会议时间">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="会议地点"
										  :span="2">{{ form.meetingPlace }}</el-descriptions-item>
					<el-descriptions-item label="参会人员"
										  :span="2">
						{{ form.confereeName }} {{ form.confereeInput }}
					</el-descriptions-item>
					<el-descriptions-item label="列席人员"
										  :span="2">
						{{ form.attendanceName }} {{ form.attendanceInput }}
					</el-descriptions-item>
					<el-descriptions-item label="会议议程"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor min500 w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.agenda"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="会议纪要内容"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor min500 w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.content"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  ref="meetingUpload"
								  tableName="audit_meeting_summary"
								  assortment="test2"
								  uploadType="2"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectMeetSummDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>